export enum LicenseStatus {
    requested = "requested",
    active = "active",
    expired = "expired",
    installed = "installed"
}
